import { Capacitor } from '@capacitor/core'

import type { ApkInstallStatus } from './apkUpdate'
import { postClientDiagnostic } from './clientDiagnostics'
import { isNativeExternalOpenAvailable } from './nativeExternalOpen'

export type ApkUpdateDiagnosticEvent = {
  event:
    | 'seen'
    | 'opening'
    | 'opened'
    | 'external_opened'
    | 'permission_required'
    | 'in_progress'
    | 'navigated'
    | 'error'
  token?: string | null
  error_code?: string | null
}

export function recordApkUpdateDiagnostic(event: ApkUpdateDiagnosticEvent): void {
  postClientDiagnostic('/api/client-diagnostics/apk-update', {
    ...event,
    native_platform: Capacitor.isNativePlatform(),
    external_open_plugin: isNativeExternalOpenAvailable(),
  })
}

export function apkUpdateDiagnosticEventForStatus(
  status: ApkInstallStatus,
): ApkUpdateDiagnosticEvent['event'] {
  if (status === 'installer_opened') return 'opened'
  return status
}
